(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-section-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    
    // 1. SKIP CART & GO TO CHECKOUT LOGIC
    // This intercepts the form submit to ensure we don't open a drawer, but go straight to checkout.
    const checkoutForm = document.getElementById('product-form-installment');
    if (checkoutForm) {
        checkoutForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const submitBtn = checkoutForm.querySelector('[type="submit"]');
            const originalText = submitBtn.innerText;
            
            // Visual feedback
            submitBtn.disabled = true;
            submitBtn.innerText = "Processing...";

            let formData = new FormData(checkoutForm);

            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                // Redirect to checkout immediately
                window.location.href = '/checkout';
            })
            .catch((error) => {
                console.error('Error:', error);
                // Fallback: If AJAX fails, try removing disabling and let user try again
                submitBtn.disabled = false;
                submitBtn.innerText = originalText;
            });
        });
    }

    // 2. CAROUSEL
    const carousels = document.querySelectorAll('.nerra-carousel');
    carousels.forEach(carousel => {
      const sectionId = carousel.id.replace('MediaCarousel-', '');
      const dots = document.querySelectorAll(`#MediaCarousel-${sectionId} + .nerra-dots .nerra-dot`);
      carousel.addEventListener('scroll', () => {
        const index = Math.round(carousel.scrollLeft / carousel.offsetWidth);
        dots.forEach(dot => dot.classList.remove('active'));
        if(dots[index]) dots[index].classList.add('active');
      });
      dots.forEach(dot => {
        dot.addEventListener('click', function() {
            carousel.scrollTo({ left: carousel.offsetWidth * parseInt(this.dataset.index), behavior: 'smooth' });
        });
      });
    });

    // 3. FOOTER TEXT ROTATOR
    const rotators = document.querySelectorAll('.nerra-text-rotator-wrapper');
    rotators.forEach(wrapper => {
        const textElement = wrapper.querySelector('.nerra-rotating-text');
        if(!textElement) return;
        const sectionId = textElement.id.replace('rotating-text-', '').replace(/-/g, '_');
        const texts = window[`nerraFooterTexts_${sectionId}`];
        const dotElements = wrapper.querySelectorAll('.r-dot');
        if (texts && texts.length > 0) {
            let currentIndex = 0;
            setInterval(() => {
                textElement.classList.add('fade-out');
                setTimeout(() => {
                    currentIndex = (currentIndex + 1) % texts.length;
                    textElement.innerText = texts[currentIndex];
                    dotElements.forEach(d => d.classList.remove('active'));
                    if(dotElements[currentIndex]) dotElements[currentIndex].classList.add('active');
                    textElement.classList.remove('fade-out');
                }, 300);
            }, 3000);
        }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nerra-custom"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.getElementById('CustomHeader');
    const placeholder = document.getElementById('HeaderPlaceholder');
    const trigger = document.getElementById('MenuToggle');
    const overlay = document.getElementById('MenuOverlay');
    const textOpen = trigger ? trigger.querySelector('.menu-text') : null;
    const textClose = trigger ? trigger.querySelector('.menu-icon-close') : null;

    let headerOffset = header.offsetTop;

    // 1. Force Sticky on Scroll
    function handleScroll() {
      // If we scroll past the header's original position
      if (window.scrollY > headerOffset) {
        if (!header.classList.contains('is-fixed')) {
          // Set placeholder height to prevent jump
          placeholder.style.display = 'block';
          placeholder.style.height = header.offsetHeight + 'px';
          // Lock header
          header.classList.add('is-fixed');
        }
      } else {
        if (header.classList.contains('is-fixed')) {
          // Unlock header
          header.classList.remove('is-fixed');
          placeholder.style.display = 'none';
          placeholder.style.height = '0';
        }
      }
    }
    
    // Recalculate offset on resize (in case banner size changes)
    window.addEventListener('resize', function() {
      if(!header.classList.contains('is-fixed')) {
        headerOffset = header.offsetTop;
      }
    });

    window.addEventListener('scroll', handleScroll);

    // 2. Menu Logic
    function toggleMenu() {
      header.classList.toggle('menu-open');
      
      if (header.classList.contains('menu-open')) {
         // Force solid background if menu opens
         header.classList.add('is-fixed'); 
         if(textOpen) textOpen.style.display = 'none';
         if(textClose) textClose.style.display = 'inline';
      } else {
         if(window.scrollY <= headerOffset) header.classList.remove('is-fixed');
         if(textOpen) textOpen.style.display = 'inline';
         if(textClose) textClose.style.display = 'none';
      }
    }

    if(trigger) trigger.addEventListener('click', toggleMenu);
    if(overlay) overlay.addEventListener('click', toggleMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
